export interface TaskManagerPeriodFilterType {
  selectedTaskManagerPeriod: server.dto.TaskManagerPeriodFilters
}

export const DefaultTaskManagerPeriodFilter: server.dto.TaskManagerPeriodFilters = "allTasks";

export const initialTaskManagerPeriodFilter: TaskManagerPeriodFilterType = {
  selectedTaskManagerPeriod: DefaultTaskManagerPeriodFilter
};